import { render, staticRenderFns } from "./DrillPenMath.vue?vue&type=template&id=343f5e37&scoped=true&lang=pug&"
import script from "./DrillPenMath.vue?vue&type=script&lang=ts&"
export * from "./DrillPenMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillPenMath.vue?vue&type=style&index=0&id=343f5e37&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343f5e37",
  null
  
)

export default component.exports